import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import cx from 'classnames';
import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  titleChildren: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  onClick?: () => void;
  iconColor?: string;
}>;

const Accordion = ({ children, defaultOpen = false, titleChildren, className, onClick, iconColor }: Props) => {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div className="flex flex-col">
          <Disclosure.Button onClick={onClick} className={cx('flex justify-between space-x-4', className)}>
            <div>{titleChildren}</div>
            <div>
              <div
                className="rounded-sm bg-transparent p-1 hover:bg-gray-50/10"
                style={{
                  color: iconColor,
                }}
              >
                <ChevronUpIcon
                  className={cx(
                    'transition-50 h-4 w-4 transition-transform',
                    open ? 'rotate-0' : 'rotate-180 transform',
                  )}
                />
              </div>
            </div>
          </Disclosure.Button>

          <Disclosure.Panel>{children}</Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

export default Accordion;
